
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proposal",
      function () {
        return require("private-next-pages/proposal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proposal"])
      });
    }
  